export const ATTENDANCE_STATUSES = {
  ASSIGNED: "Assigned",
  ON_TIME: "On Time",
  LATE: "Late",
  LATE_ALLOWED_TO_WORK: "Late Allowed to Work",
  LATE_SENT_HOME: "Late Sent Home",
  ABSENT: "Absent",
  CANCELLED: "Cancelled",
  VTO: "VTO",
  ANNUAL_LEAVE: "Annual Leave",
  EMERGENCY_LEAVE: "Emergency Leave",
  MEDICAL_LEAVE: "Medical Leave",
  UNPAID_LEAVE: "Urgent / Unpaid Leave",
  CHILD_CARE_LEAVE: "Child Care Leave",
  HOSPITALIZATION_LEAVE: "Hospitalization Leave",
};

export const ATTENDANCE_STATUSES_ID = {
  ASSIGNED: 1,
  ON_TIME: 2,
  LATE: 3,
  LATE_ALLOWED_TO_WORK: 4,
  LATE_SENT_HOME: 5,
  ABSENT: 6,
  CANCELLED: 7,
  VTO: 8,
  ANNUAL_LEAVE: 9,
  EMERGENCY_LEAVE: 10,
  MEDICAL_LEAVE: 11,
  URGENT_LEAVE: 12,
  CHILD_CARE_LEAVE: 13,
  HOSPITALIZATION_LEAVE: 14,
  ON_LEAVE: 15,
};

export const REQUEST_STATUSES = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

export const CLAIM_TYPES = {
  TRANSPORTATION: 4,
  STAFF_PURCHASE: 8,
  SAFETY_SHOES: 12,
};
